var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCylinder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.795,
    height: 52.458,
    viewBox: "0 0 26.795 52.458",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke-miterlimit:10;stroke-width:2px;}.a{stroke:#40b895;}.b{stroke:#4f4f4f;stroke-linecap:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 24.053,
    transform: "translate(0.742 26.299)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y1: 3.261,
    transform: "translate(12.397 4.18)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y1: 7.441,
    transform: "translate(8.029)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y1: 7.441,
    transform: "translate(17.013)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M181.256,155.824H159.7a1.623,1.623,0,0,1-1.618-1.618V119.728a1.623,1.623,0,0,1,1.618-1.618h21.558a1.623,1.623,0,0,1,1.618,1.618v34.477A1.623,1.623,0,0,1,181.256,155.824Z",
    transform: "translate(-158.08 -110.669)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 19.118,
    transform: "translate(2.649 50.458)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 17.659,
    transform: "translate(3.685)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCylinder);
export default __webpack_public_path__ + "static/media/cylinder.afe8e900e37af8aaa2f021a8721fbb5d.svg";
export { ForwardRef as ReactComponent };